






































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import IconSync from '@/app/ui/assets/icon_sync.vue'
import Tabs from '@/app/ui/components/Tabs/index.vue'
import CODSearchInput from '../../COD/components/CODSearchInput/index.vue'
import {
  DataObject,
} from '@/app/ui/components/DataTableV2/type'
import FilterGroup from '@/app/ui/components/FilterGroup/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DropdownCheckbox from '@/app/ui/components/DropdownCheckbox/index.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import PickupController from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'
import {
  PickupCorporate,
  PickupCorporateNfdDeadlineSummary,
  PickupCorporatesV2,
} from '@/domain/entities/Pickup'
import dayjs from 'dayjs'
import dayjsDuration from 'dayjs/plugin/duration'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import ModalExportCorporate from '../components/Modals/ModalExportPickupCorporate.vue'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import { ExportPickupRequest } from '@/data/payload/api/PickupRequest'
import PickupCorporateDeadlineSummaryStrip from './components/PickupCorporateDeadlineSummaryStrip/index.vue'
import PickupCorporateTable from './components/PickupCorporateTable/index.vue'
import {
  buildBucketItemsFromCounts,
  PickupCorporateDeadlineBucketItem
} from './components/PickupCorporateDeadlineBuckets/index'
import {
    mapSpecialHandlingCode,
  PickupCorporateTableRow,
  PickupCorporateTableSort
} from './components/PickupCorporateTable/index.types'
import PickupCorporateHeader from "./components/PickupCorporateHeader/index.vue";
import { PickupCorporateFilterModel, PickupCorporateKeywordField, toListQueryFilterPayload } from './components/PickupCorporateFilter/index.types'
import PickupCorporateFilterRow from './components/PickupCorporateFilter/index.vue'
import { FlagsAccount } from '@/feature-flags'

dayjs.extend(dayjsDuration)

type ArmadaTab = 'motor' | 'mobil'

@Component({
  components: {
    Button,
    IconSync,
    Tabs,
    CODSearchInput,
    FilterGroup,
    DropdownSelect,
    DropdownCheckbox,
    DataTableV2,
    PaginationNav,
    ModalExportCorporate,
    WidgetDownload,
    EyeIcon,
    EyeDisabledIcon,
    PickupCorporateDeadlineSummaryStrip,
    PickupCorporateTable,
    PickupCorporateHeader,
    PickupCorporateFilterRow
  },
})
class PickupCorporateList extends Vue {
  utils = Utils
  controller = PickupController
  activeArmadaTab: ArmadaTab = 'motor'
  latestSyncDisplay = "";
  isSyncLoading = false;

  tableSort: PickupCorporateTableSort | null = null

  get hideOriginCountryFilter(): boolean {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  @Watch('hideOriginCountryFilter')
  hideOriginCountryFilterChanged() {
    this.syncPickupCorporate();
  }

  // Filter Model Controlled State
  filterModel: PickupCorporateFilterModel = {
    keyword: '',
    keywordField: 'order_id',
    estimatePickupTime: null,
    originCountry: null,
    specialHandling: [],
    cancelReason: [],
    executionPlatform: ''
  }

  // State One-at-a-time phone reveal (Parent Wire)
  revealedPhoneShipmentId: string | null = null

  get itemTabs(): { value: string; label: string }[] {
    return [
      { label: 'Pick Up via motor', value: 'motor' },
      { label: 'Pick Up via mobil', value: 'mobil' },
    ]
  }

  parameters = {
    page: 1,
    perPage: 10
  }

  tableData: DataObject[][] = []
  showModalExportCorporate = false;

  // ponytail: eye-toggle reveal; list API sends empty values, so reveal assigns from adminContactShow
  revealed: Set<string> = new Set()

  isRevealed(shipmentId: string, field: string): boolean {
    return this.revealed.has(`${shipmentId}-${field}`)
  }

  findItem(shipmentId: string): PickupCorporate | undefined {
    return this.controller.pickupCorporateData.find(p => p.shipmentId === shipmentId)
  }

  async showField(shipmentId: string): Promise<void> {
    if (!shipmentId) return
    const item = this.findItem(shipmentId)
    if (!item) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipment',
        resourceId: shipmentId,
        field: 'pickup_phone',
        source: 'pickup_corporate'
      })
      if (item.pickup) item.pickup.phoneNumber = resp.value || '-'
      this.revealed.add(`${shipmentId}-phone`)
      this.revealed = new Set(this.revealed)
    } catch {
      /* ignore */
    }
  }

  hideField(shipmentId: string): void {
    const item = this.findItem(shipmentId)
    if (item?.pickup) {
      item.pickup.phoneNumber = ''
    }
    this.revealed.delete(`${shipmentId}-phone`)
    this.revealed = new Set(this.revealed)
  }

  mounted(): void {
    this.syncPickupCorporate();
  }

  get latestSync(): string {
    if (!this.controller.latestSync) {
      return ''
    }

    return dayjs(this.controller.latestSync).format('DD-MM-YY HH:mm')
  }

  get summaryData(): PickupCorporateNfdDeadlineSummary {
    return this.controller.pickupCorporateNfdDeadlineSummary
  }

  get totalSummaryData(): number {
    return this.summaryData.totalInBuckets;
  }

  get deadlineBucketItems(): PickupCorporateDeadlineBucketItem[] {
    return buildBucketItemsFromCounts({
      three_hours_left: this.summaryData.buckets.threeHoursLeft,
      two_hours_left: this.summaryData.buckets.twoHoursLeft,
      one_hour_left: this.summaryData.buckets.oneHourLeft,
      late_one_hour: this.summaryData.buckets.lateOneHour,
      late_two_hours: this.summaryData.buckets.lateTwoHours,
      late_over_three_hours: this.summaryData.buckets.lateOverThreeHours
    });
  }

  get tableRows(): PickupCorporateTableRow[] {
    return this.controller.pickupCorporateDataV2.map((item, index) => {
      const endDate = Number(item.estimatePickupTime.split(':')[0]) + 1;
      return {
        rowNumber: index + 1,
        shipmentId: item.shipmentId,
        customerName: item.pickup.fullname,
        phoneMaskedDisplay: '********',
        phonePlainDisplay: item.pickup.phoneNumber,
        clientLabel: `(${item.clientId}-${item.clientName})`,
        isPhoneRevealed: false,
        specialHandlingLabels: Array.isArray(item.specialHandling) ? item.specialHandling.map(d => ({flag: d, code: mapSpecialHandlingCode(d)})) : [],
        executionPlatform: item.executionPlatform,
        estimateKoliBeratLabel: `${item.estimateTotalKoli} koli/${item.estimateTotalTonase}kg`,
        crrnfdDate: Utils.formatTimeZone(
          Utils.formatDateWithIDLocale(item.history.createdAt, "DD MMMM YYYY")
        ),
        crrnfdTime: Utils.formatTimeZone(
          Utils.formatDateWithIDLocale(item.history.createdAt, "HH:mm Z.")
        ),
        estimateScheduleDate: item.estimatePickupDate,
        estimateScheduleTimeRange: item.estimatePickupTime + ` - ${endDate.toString().padStart(2, '0')}:00`,
        nfdCount: item.totalNfd,
        isPhoneRevealLoading: false,
        latitude: item.pickup.latitude,
        longitude: item.pickup.longitude,
        isAddressRevealLoading: false,
        note: item.pickup.note

      } as PickupCorporateTableRow
    })
  }

  get exportPayload() {
    const queryFilter = toListQueryFilterPayload(
      this.filterModel,
      this.hideOriginCountryFilter
    )

    const finalQueryParams = {
      ...queryFilter,
      armada_tab: this.activeArmadaTab,
      statusId: 'CRRNFD',
      originCountry: this.hideOriginCountryFilter ? 'Malaysia' : queryFilter.originCountry
    }

    return finalQueryParams
  }

  fetchPickup(reset = false): void {
    if (reset) {
      this.parameters.page = 1
    }
    const queryFilter = toListQueryFilterPayload(
      this.filterModel,
      this.hideOriginCountryFilter
    )

    const finalQueryParams = {
      ...queryFilter,
      sort_field: this.tableSort?.field || '',
      sort_direction: this.tableSort?.direction || '',
      armada_tab: this.activeArmadaTab,
      page: this.parameters.page,
      per_page: this.parameters.perPage,
      date_from: Utils.formatDateWithIDLocale(
        new Date(new Date().setDate(new Date().getDate() - 31)).toISOString(),
        'YYYY-MM-DD'
      ),
      statusId: 'CRRNFD',
      originCountry: this.hideOriginCountryFilter ? 'Malaysia' : queryFilter.originCountry,
      execution_platform: this.filterModel.executionPlatform
    } as any

    (this.$refs.table as any).resetRevealed();

    this.controller.fetchPickupCorporateListV2(finalQueryParams)
    this.controller.fetchCorporateNfdDeadlineSummary(finalQueryParams)
  }

  async onTabsClick(value: string): Promise<void> {
    if (value !== 'motor' && value !== 'mobil') return
    if (value === this.activeArmadaTab) return
    this.activeArmadaTab = value
    this.onFilterReset(false);
    await this.$nextTick();
    await this.syncPickupCorporate();
  }

  onFilterReset(fetchList = true): void {
    this.filterModel = {
      keyword: '',
      keywordField: 'order_id',
      estimatePickupTime: null,
      originCountry: null,
      specialHandling: [],
      cancelReason: [],
      executionPlatform: ''
    }
    if (fetchList) this.fetchPickup(true);
  }

  onTableSort(sort: PickupCorporateTableSort): void {
    this.tableSort = sort
    this.fetchPickup(true)
  }

  onRevealPhone(payload: { shipmentId: string }): void {
    this.showField(payload.shipmentId);
  }

  onHidePhone(payload: { shipmentId: string }): void {
    this.hideField(payload.shipmentId);
  }

  onManualAssign(payload: { shipmentId: string }): void {
    this.$router.push({
      name: 'PickupCorporateManualAssignee',
      params: { shipmentId: payload.shipmentId }
    })
  }

  onPageChange(payload: { page: number }): void {
    this.parameters.page = payload.page
    this.fetchPickup()
  }

  onPerPageChange(payload: { perPage: number }): void {
    this.parameters.perPage = payload.perPage
    this.fetchPickup(true)
  }

  private tableCellMapper(
    value: string | number | string[] | boolean[] | number[],
    colWidth: string
  ): DataObject {
    return {
      value: <string>value,
      customStyle: {
        maxWidth: colWidth,
        minWidth: colWidth,
      },
    }
  }

  public formatNFDStatus(value: string | number): string {
    const status = parseInt(<string>value)
    if (status === 1) return 'one'
    if (status === 2) return 'two'
    if (status === 3) return 'three'
    if (status === 4) return 'four'
    if (status === 5) return 'five'
    return 'more'
  }

  public getOverSLA(createdAt: string): boolean {
    return dayjs().diff(dayjs(createdAt), 'hours') >= 48
  }

  public isBosspack(productType: string): boolean {
    return productType.includes('BOSSPACK')
  }

  public getDuration(createdAt: string): string {
    const duration = dayjs.duration(dayjs().diff(dayjs(createdAt)))

    const result = []

    //Get Days
    const days = Math.floor(duration.asDays())
    if (days) {
      result.push(`${days}d`)
    }

    //Get Hours
    const hours = duration.hours()
    if (hours) {
      result.push(`${hours}h`)
    }

    //Get Minutes
    const minutes = duration.minutes()
    result.push(`${minutes}m`)

    return result.join(', ')
  }

  onSearchFieldChange(payload: { keywordField: PickupCorporateKeywordField }): void {
    this.filterModel.keywordField = payload.keywordField
  }

  onFilterChange(newFilter: PickupCorporateFilterModel): void {
    this.filterModel = { ...newFilter }
    this.fetchPickup(true)
  }

  public getPickupData(index: number): PickupCorporate {
    return this.controller.pickupCorporateData[Number(index)]
  }

  public getShipmentId(index: number): string {
    return this.controller.pickupCorporateData[Number(index)]?.shipmentId || ''
  }

  public getPhoneValue(index: number): string {
    const item = this.controller.pickupCorporateData[Number(index)]
    return (item && item.pickup && item.pickup.phoneNumber) || '-'
  }

  public getlastCourier(index: number): string {
    const crr = this.controller.pickupCorporateData[index].couerierPickupDetail
    if (!crr) return '-'
    return `[${crr.courierId}] ${crr.courierName} (${crr.courierTypeValid}) ${crr.phoneNumber} • ${crr.partnerName}`
  }

  public async onExport() {
    this.showModalExportCorporate = true;
  }

  get isLoadingExportCorporate(): boolean {
    return this.controller.isLoadingExportCorporate;
  }

  public async syncPickupCorporate() {
    try {
      this.isSyncLoading = true;
      const resp = await this.controller.syncPickupCorporate();
      this.fetchPickup(true);
      this.latestSyncDisplay =  dayjs(resp).format('DD-MM-YY HH:mm')
    } finally {
      this.isSyncLoading = false;
    }
  }

  beforeDestroy() {
    this.onFilterReset(false);
  }

}
export default PickupCorporateList;
